import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22e1b7ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-Feedback" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "feedback-title" }
const _hoisted_4 = { class: "wrapper-textarea" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormTextInput = _resolveComponent("FormTextInput")!
  const _component_InputError = _resolveComponent("InputError")!
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!
  const _component_TheSuccessForm = _resolveComponent("TheSuccessForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.success)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.FeedbackConfiguration.text.title), 1),
          _createElementVNode("form", {
            id: "form-Feedback",
            class: "form-Feedback",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputsInfo, (item, index) => {
              return (_openBlock(), _createBlock(_component_FormTextInput, {
                key: index,
                type: item.type,
                name: item.name,
                label: item.placeholder,
                modelValue: _ctx.userFeedBack[item.name],
                "onUpdate:modelValue": ($event: any) => ((_ctx.userFeedBack[item.name]) = $event),
                errors: 
                        !_ctx.checkErrorsReturn(
                            _ctx.messageResponse[_ctx.capitalize(item.name)]
                        )
                            ? _ctx.messageResponse[_ctx.capitalize(item.name)]
                            : item.error
                    ,
                isInvalid: 
                        !_ctx.checkErrorsReturn(
                            _ctx.messageResponse[_ctx.capitalize(item.name)]
                        )
                            ? true
                            : _ctx.inputValidationStatus[item.name] ==
                              _ctx.EValidity.Invalid
                    
              }, null, 8, ["type", "name", "label", "modelValue", "onUpdate:modelValue", "errors", "isInvalid"]))
            }), 128)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", {
                class: _normalizeClass(["label-textarea", {
                            'textarea-focus': _ctx.inFocus || _ctx.filled ? true : false,
                        }])
              }, " Mensagem ", 2),
              _withDirectives(_createElementVNode("textarea", {
                name: "Feedback",
                id: "Feedback",
                class: _normalizeClass(["textarea-input", {
                            invalid: _ctx.validLocalTextArea(
                                _ctx.messageResponse.Message
                            ),
                        }]),
                cols: "40",
                rows: "10",
                required: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userFeedBack.message) = $event)),
                onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focusTextArea && _ctx.focusTextArea(...args))),
                onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.outFocusTextArea && _ctx.outFocusTextArea(...args)))
              }, null, 34), [
                [_vModelText, _ctx.userFeedBack.message]
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_InputError, {
                msg: 
                            !_ctx.checkErrorsReturn(_ctx.messageResponse.Message)
                                ? _ctx.messageResponse.Message
                                : _ctx.FeedbackConfiguration.text.errorTextArea
                        
              }, null, 8, ["msg"])
            ], 512), [
              [_vShow, _ctx.validLocalTextArea(_ctx.messageResponse.Message)]
            ]),
            _createVNode(_component_ButtonDefault, {
              id: "btn-submit-contact-form",
              onButtonClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitFeedBack()))
            })
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_TheSuccessForm, {
      buttonLabel: "Fechar",
      messages: _ctx.FeedbackConfiguration.text.success,
      onNewRequestClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.newFeedback())),
      useRateStar: false
    }, null, 8, ["messages"]), [
      [_vShow, _ctx.success]
    ])
  ]))
}